module.exports = __webpack_public_path__ + "img/mom2.d6e2aa39.png";